var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Wrap-Section"},[_c('section',[_c('div',{staticClass:"Logo"},[_c('img',{attrs:{"src":require('@/assets/img/logo.svg'),"alt":"Logo"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }